import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_UPLOADS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Uploads = lazy(() =>
  import('../../../screens/Uploads')
    .then(module => ({default: module.Uploads})));

const UploadsNavigation = [
  {
    path: ROUTE_UPLOADS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Uploads />
      </Suspense>
    ),
  },
];

export default UploadsNavigation;
